/**
 * @Author: Calvin Green <calvin>
 * @Date:   2022-03-18T14:07:39+02:00
 * @Email:  calvin@diversitude.com
 * @Last modified by:   calvin
 * @Last modified time: 2022-08-04T20:42:04+02:00
 * @Copyright: Diversitude 2022
 */



import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },

    component: () => import('./views/dashboards/default'),
  },

  //* START - Global routes (Used for client, client_admin, ccb_admin)
  {
    path: '/documents',
    name: 'documents',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/sop/documents.vue'),
  },
  {
    path: '/documents/view/:document_id',
    name: 'document_view',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/sop/documentView.vue'),
  },
  {
    path: '/documents/edit/:document_id',
    name: 'document_edit',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/sop/documentEdit.vue'),
  },
  {
    path: '/distribution/:document_id',
    name: 'distribution',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/sop/distribution.vue'),
  },
  {
    path: '/stats/:document_id',
    name: 'stats',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/sop/stats.vue'),
  },




  //* START CLIENT ROUTES
  {
    path: '/client/timeline',
    name: 'project_timeline',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
          if (store.getters['clientAdmin/userType'] == 'client') {
            next();
          } else {
            //redirect to client screen
            next({ name: 'default' });
          }
      },
    },
    component: () => import('./views/client/project-timeline.vue'),
  },
  {
    path: '/client/administration',
    name: 'client_administration',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
          if (store.getters['clientAdmin/userType'] == 'client') {
            next();
          } else {
            //redirect to client screen
            next({ name: 'default' });
          }
      },
    },
    component: () => import('./views/client/administration.vue'),
  },
  {
    path: '/client/documents',
    name: 'client_documents',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
          if (store.getters['clientAdmin/userType'] == 'client') {
            next();
          } else {
            //redirect to client screen
            next({ name: 'default' });
          }
      },
    },
    component: () => import('./views/client/documents.vue'),
  },
  //* END CLIENT ROUTES



  //* START CLIENT ADMIN ROUTES */
  {
    path: '/clientadmin/documents',
    name: 'clientadmin_documents',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['clientAdmin/userType'] == 'client_admin') {
          next();
        } else {
          //redirect to client screen
          next({ name: 'default' });
        }
      },
    },
    component: () => import('./views/client_admin/documents.vue'),
  },
  {
    path: '/clientadmin/timeline',
    name: 'clientadmin_project_timeline',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
          if (store.getters['clientAdmin/userType'] == 'client_admin') {
            next();
          } else {
            //redirect to client screen
            next({ name: 'default' });
          }
      },
    },
    component: () => import('./views/client/project-timeline.vue'),
  },
  {
    path: '/clientadmin/administration',
    name: 'client_admin_administration',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
          if (store.getters['clientAdmin/userType'] == 'client_admin') {
            next();
          } else {
            //redirect to client screen
            next({ name: 'default' });
          }
      },
    },
    component: () => import('./views/client_admin/administration.vue'),
  },
  {
    path: '/clientadmin/facility',
    name: 'client_admin_facility',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
          if (store.getters['clientAdmin/userType'] == 'client_admin') {
            next();
          } else {
            next({ name: 'default' });
          }
      },
    },
    component: () => import('./views/client_admin/facility.vue'),
  },

  //* END CLIENT ROUTES



  //* START CCB ADMIN ROUTES
  {
    path: '/admin/dashboard',
    name: 'admin_dashboard',
    meta: {
      authRequired: true,
      //eslint-disable-next-line
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['clientAdmin/userType'] == 'admin') {
          next();
        } else {
          //redirect to client screen
          next({ name: 'default' });
        }
      },
    },
    component: () => import('./views/admin/dashboard.vue'),
  },
  {
    path: '/admin/applicants',
    name: 'applicants',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['clientAdmin/userType'] == 'admin') {
          next();
        } else {
          //redirect to client screen
          next({ name: 'default' });
        }
      },
    },
    component: () => import('./views/admin/applicants.vue'),
  },
  {
    path: '/admin/administration',
    name: 'ccb_administration',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['clientAdmin/userType'] == 'admin') {
          next();
        } else {
          //redirect to client screen
          next({ name: 'default' });
        }
      },
    },
    component: () => import('./views/admin/administration.vue'),
  },
  {
    path: '/admin/documents',
    name: 'documents_old',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['clientAdmin/userType'] == 'admin') {
          next();
        } else {
          //redirect to client screen
          next({ name: 'default' });
        }
      },
    },
    component: () => import('./views/admin/documents.vue'),
  },
  {
    path: '/admin/sop',
    name: 'sop',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['clientAdmin/userType'] == 'admin') {
          next();
        } else {
          //redirect to client screen
          next({ name: 'default' });
        }
      },
    },
    component: () => import('./views/admin/sop'),
  },
  {
    path: '/admin/sop/edit',
    name: 'sop-edit',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['clientAdmin/userType'] == 'admin') {
          next();
        } else {
          //redirect to client screen
          next({ name: 'default' });
        }
      },
    },
    component: () => import('./views/admin/editSop'),
  },
  {
    path: '/testzone',
    name: 'testzone',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/testzone'),
  },
  {
    path: '/wizard',
    name: 'wizard',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/admin/userWizard'),
  },

  {
    path: '/users',
    name: 'users',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/admin/users'),
  },
  {
    path: '/clients',
    name: 'clients',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/admin/clients'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: "/reset-password/:token",
    name: "reset",
    component: () => import("./views/account/reset-password"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/profile',
    name: 'profile',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/profile'),
  },



  //* folia misc
  {
    path: '/foliarequest/:token',
    name: 'Sample request',
    component: () => import('./views/external/FoliaSampleRequest'),
  },
  {
    path: '/foliastock/view/:token',
    name: 'Stock overview',
    component: () => import('./views/external/FoliaStockOverview'),
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        //! Testing only
        window.localStorage.removeItem('x_token');
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else {
          store.dispatch('authfack/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },

]
